const coterie: AppointmentDialogOverride = {
  subHeader: 'Connect your Coterie direct appointment',
  dialogBodyHTML: `<p>
  If you already have a Coterie direct appointment, Bold Penguin will fetch
  the credentials automatically based on the email you provide.
</p>`,
  subAppointmentText: `Coterie sub-appointment activation is instant, so you
    can begin quoting immediately. You will receive a confirmation email from
    Coterie, plus an approval to bind policies within 48 hours.`,
  dialogActionButtons: {
    cancelText: 'Cancel',
    submitText: 'Confirm',
    disableSubmit: false,
  },
};
const nextcarrier: AppointmentDialogOverride = {
  subHeader: '',
  dialogBodyHTML: '',
  subAppointmentText: `NEXT sub-appointment activation is instant, so you can begin quoting immediately.`,
  dialogActionButtons: {
    cancelText: '',
    submitText: '',
    disableSubmit: false,
  },
};
const berkleycarrier: AppointmentDialogOverride = {
  subHeader: '',
  dialogBodyHTML: '',
  subAppointmentText: `Bold Penguin will request a sub-appointment for you.
    Appointment activations for Berkley Management Protection can take 1-2
    business days to process. You will receive a confirmation email as soon
    as your appointment has been activated.`,
  dialogActionButtons: {
    cancelText: '',
    submitText: '',
    disableSubmit: false,
  },
};
const atbay: AppointmentDialogOverride = {
  subHeader: '',
  dialogBodyHTML: '',
  subAppointmentText:
    'At Bay sub-appointment activation is instant, so you can begin quoting immediately.',
  dialogActionButtons: {
    cancelText: '',
    submitText: '',
    disableSubmit: false,
  },
};

export const DirectAppointmentDialogOverridesMap = {};

export const SubAppointmentDialogOverridesMap = {
  berkleycarrier,
  coterie,
  nextcarrier,
  atbay,
};

export enum DirectAppointmentButtonOverrides {
  CancelText = 'cancelText',
  SubmitText = 'submitText',
  DisableSubmit = 'disableSubmit',
}

interface AppointmentDialogOverride {
  subHeader: string;
  dialogBodyHTML: string;
  subAppointmentText: string;
  dialogActionButtons: {
    cancelText: string;
    submitText: string;
    disableSubmit: boolean;
  };
}
